import React from 'react';

const Content = (props) => {
    const handicap = (props.content.Handicap) ? props.content.Handicap.replace(/\*(.*?)\*/g, "<strong>$1</strong>") : false;
    const birdies = (props.content.Achievements && props.content.Achievements.Birdies) ? props.content.Achievements.Birdies.replace(/\*(.*?)\*/g, "<strong>$1</strong>") : false;
    const eagles = (props.content.Achievements && props.content.Achievements.Eagles) ? props.content.Achievements.Eagles.replace(/\*(.*?)\*/g, "<strong>$1</strong>") : false;
    const albatrosses = (props.content.Achievements && props.content.Achievements.Albatrosses) ? props.content.Achievements.Albatrosses.replace(/\*(.*?)\*/g, "<strong>$1</strong>") : false;
    const holeinones = (props.content.Achievements && props.content.Achievements.HoleInOnes) ? props.content.Achievements.HoleInOnes.replace(/\*(.*?)\*/g, "<strong>$1</strong>") : false;

    return (
        <div className="c-linkBlock__content">
            {props.imageUrl && <img src={props.imageUrl} alt="" className="c-linkBlock__image" />}
            {(handicap || birdies || eagles || albatrosses || holeinones) &&
                <div className="c-achievementsList">
                    {handicap &&
                        <div className="c-achievementsList__achievement">
                            <div className="c-achievementsList__achievement__icon c-achievementsList__achievement__icon--handicap">
                                <svg className="c-icon c-icon--handicap--large">
                                    <use xlinkHref="#handicap" />
                                </svg>
                            </div>
                            <div className="c-achievementsList__achievement__text" dangerouslySetInnerHTML={{__html: handicap}}></div>
                        </div>
                    }
                    {birdies &&
                        <div className="c-achievementsList__achievement">
                            <div className="c-achievementsList__achievement__icon">
                                <svg className="c-icon c-icon--birdie">
                                    <use xlinkHref="#birdie" />
                                </svg>
                            </div>
                            <div className="c-achievementsList__achievement__text" dangerouslySetInnerHTML={{__html: birdies}}></div>
                        </div>
                    }
                    {eagles &&
                        <div className="c-achievementsList__achievement">
                            <div className="c-achievementsList__achievement__icon">
                                <svg className="c-icon c-icon--eagle">
                                    <use xlinkHref="#eagle" />
                                </svg>
                            </div>
                            <div className="c-achievementsList__achievement__text" dangerouslySetInnerHTML={{__html: eagles}}></div>
                        </div>
                    }
                    {albatrosses &&
                        <div className="c-achievementsList__achievement">
                            <div className="c-achievementsList__achievement__icon">
                                <svg className="c-icon c-icon--albatros">
                                    <use xlinkHref="#albatros" />
                                </svg>
                            </div>
                            <div className="c-achievementsList__achievement__text" dangerouslySetInnerHTML={{__html: albatrosses}}></div>
                        </div>
                    }
                    {holeinones &&
                        <div className="c-achievementsList__achievement">
                            <div className="c-achievementsList__achievement__icon">
                                <svg className="c-icon c-icon--hole-in-one">
                                    <use xlinkHref="#hole-in-one" />
                                </svg>
                            </div>
                            <div className="c-achievementsList__achievement__text" dangerouslySetInnerHTML={{__html: holeinones}}></div>
                        </div>
                    }
                </div>
            }
            {props.content.Text && props.content.Url &&
                <div className="c-linkBlock__content__cta">
                    <a href={props.content.Url} target="_blank" className="c-button c-button--action">{props.content.Text}</a>
                </div>
            }
        </div>
    );
}

Content.propTypes = {
    content: React.PropTypes.shape({
        Handicap: React.PropTypes.string,
        ImageUrl: React.PropTypes.string,
        Achievements: React.PropTypes.shape({
            Birdies: React.PropTypes.string,
            Eagles: React.PropTypes.string,
            Albatrosses: React.PropTypes.string,
            HoleInOnes: React.PropTypes.string
        })
    }),
    imageUrl: React.PropTypes.string
};

export default Content;
